(() => {
  'use strict';
  const uuidIds = {"00573d7e-7870-4080-9a4f-65050f80fba5": "1361075683", "0b27fc83-7177-412f-b5ee-39a2e8a793df": "887150329", "1438c72e-f06c-4427-a355-5f5dd60590e3": "1076280282", "14ba0595-b57e-404f-a6ee-e734e0eda594": "980876463", "1b73018f-0a4e-4f78-9fd9-f51e58f3a2ee": "831103248", "1c631d5b-2726-432b-8b84-9544694b0b12": "1322436698", "2a3db237-8f2e-4225-8bd0-dc2f6275acb5": "1369291866", "2dc846af-2352-470b-ad1e-ea915c07c2aa": "913336170", "2f49f606-99f2-46bd-8a8f-75f129c8c631": "984014558", "31384cbb-1d30-4708-9947-f6b0c0c390a6": "1342487511", "3aaf1a66-81d6-4f61-a6a5-ec779b5090c2": "1224850171", "3abe39f5-b9c0-41ad-8926-bebb9b99abba": "1359210962", "3ccea62b-2663-4231-9d33-f63756632ae9": "1229537445", "4c569256-5964-429e-aeff-65c329d9d5b8": "841099410", "620ac085-8366-4526-8540-d773200b35ee": "841102461", "62fe0216-0675-4ad7-a764-d84ab7a29665": "831101773", "6c09823c-2ad2-4bcb-bb89-1dbeefc65582": "820701559", "6d19adb5-15ee-4c77-8059-de506021a546": "1182363229", "7bacd72e-78e7-4b3e-bb32-48a95d35b786": "919757788", "80caf152-c8fb-437d-9334-4f2985feb5b4": "1361062243", "911bc664-3c94-47dd-af6b-e11f9c737571": "913344609", "924a83f7-2c3a-4e89-8284-40395f865ef8": "1313351469", "954664b8-1406-4f71-b5ce-70afc822aac7": "1361076157", "9988f26f-ad83-4d6b-9bed-0b81334e20e5": "992721696", "9b974a3b-1ba0-534b-ae0e-b2971acc7eb1": "1375454010", "a4c282f2-8c67-40b5-bed5-01c74c2d99bf": "944653336", "a9f143f3-170c-430c-9ced-e49fa06c60ca": "1353803896", "ba936bb6-c455-41b7-aa59-69c85f7a8420": "1360592389", "bc854e73-db66-4af6-bf44-3c57c3380ca8": "883649136", "c21c338a-5fe7-4fcd-b714-42904c493f74": "917355874", "c2747a82-a984-4bd4-918d-9aebdfaa0d0b": "1361061305", "cd4200cb-7634-4b2d-a6bf-b9cc4e80b0c6": "1052721799", "deb7011a-20a7-4b2c-bc68-7e7ef87b2937": "831105519", "e147eb1f-4364-480c-b547-3413ea711e22": "1046448174", "e58e9e86-5452-4514-a245-9e608859330e": "1376564951", "fc5bcaf0-5c04-4b85-82df-5f318f1ae3ba": "831075640", "fe794337-c19a-418b-acf9-dc7c96e98ee6": "1342489351", "fe86bfdb-afc8-415f-98eb-613588943f49": "910060229"};
  const normalize = value => String(value || '').normalize('NFC').replace(/\s+/gu, ' ').trim();
  // day === null: the widget exposes no review date (jm v2025); id, title, body and score still gate.
  const resolve = (nativeId, title, body, score, day, rows) => {
    const bound = [...rows].filter(([, row]) => row && row.dataset.nativeReviewUuid === nativeId);
    if (bound.length > 1) return null;
    const legacyId = uuidIds[nativeId] || (/^\d+$/.test(nativeId) ? nativeId : null);
    let id = legacyId;
    if (bound.length === 1) {
      const [boundId, boundRow] = bound[0];
      if (!/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/.test(nativeId) ||
          !/^[1-9]\d*$/.test(boundId) || boundRow.dataset.reviewId !== boundId ||
          (legacyId && legacyId !== boundId)) return null;
      id = boundId;
    }
    if (!id || !rows.has(String(id))) return null;
    const row = rows.get(String(id));
    if (row.dataset.nativeReviewUuid && /^[0-9a-f-]{36}$/.test(nativeId) && row.dataset.nativeReviewUuid !== nativeId) return null;
    if (normalize(title) !== normalize(row.dataset.sourceTitle) ||
        normalize(body) !== normalize(row.dataset.sourceBody) ||
        String(score) !== row.dataset.sourceScore ||
        (day !== null && String(day).slice(0, 10) !== row.dataset.sourceDay)) return null;
    return row;
  };
  // Stored source replies abbreviate the customer's first name ("Bonjour A.") where the live reply spells it out
  // ("Bonjour Anais"); every other character must match. Whitespace is ignored: textContent drops reply <br>s.
  const escapeRe = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const sameReply = (live, source) => {
    const a = normalize(live), b = normalize(source);
    if (a.replace(/\s/gu, '') === b.replace(/\s/gu, '')) return true;
    if (!b) return false;
    const pattern = b.split(/((?<!\p{L})\p{Lu}\.|\s+)/u).map(part => (/^\s+$/u.test(part) ? '\\s*'
      : /^\p{Lu}\.$/u.test(part) ? `${part[0]}(?:\\.|\\p{Ll}+)` : escapeRe(part))).join('');
    return new RegExp(`^${pattern}$`, 'u').test(a);
  };
  // jm v2025 stars carry only a localized aria-label ("4 out of 5 stars", "5つ星のうち4"): score = the non-max number.
  const scoreFromLabel = label => {
    const nums = (String(label || '').match(/\d+/g) || []).map(Number);
    if (nums.length !== 2 || !nums.includes(5)) return null;
    return String(nums[0] === 5 ? nums[1] : nums[0]);
  };
  const text = (node, selector) => { const el = node.querySelector(selector); return el ? el.textContent : null; };
  // One adapter per Judge.me widget generation; both stay live.
  const adapters = [
    { item: '.jdgm-rev', body: '.jdgm-rev__body', anchor: '.jdgm-rev__body', reply: '.jdgm-rev__reply-content',
      id: r => r.getAttribute('data-review-id') || '', title: r => text(r, '.jdgm-rev__title'),
      score: r => { const el = r.querySelector('.jdgm-rev__rating'); return el && el.getAttribute('data-score'); },
      day: r => { const el = r.querySelector('.jdgm-rev__timestamp'); return el ? el.getAttribute('data-content') : ''; } },
    { item: '.jm-review-item[review-uuid]', body: '.jm-review-content__body', anchor: '.jm-review-body-wrapper',
      reply: '.jm-shop-reply__text',
      id: r => r.getAttribute('review-uuid') || '', title: r => text(r, '.jm-review-content__title'),
      score: r => { const el = r.querySelector('.jm-star-rating[aria-label]'); return el && scoreFromLabel(el.getAttribute('aria-label')); },
      day: () => null }
  ];
  if (typeof module !== 'undefined' && module.exports) module.exports = { resolve, normalize, uuidIds, scoreFromLabel, sameReply, adapters };
  if (typeof document === 'undefined' || window.shangmengReviewsNative) return;
  const roots = new Map();
  const attach = root => {
    if (roots.has(root)) return;
    // /pages/reviews nests the widget under its own h1; the PDP app section is root and widget at once.
    const widget = root.querySelector('[data-reviews-native-widget]') ||
      (root.hasAttribute && root.hasAttribute('data-reviews-native-widget') ? root : null);
    if (!widget) return;
    const rows = new Map();
    root.querySelectorAll('template[data-reviews-native-mt]').forEach(row => {
      const id = row.dataset.reviewId;
      if (rows.has(id)) rows.set(id, null); else rows.set(id, row);
    });
    for (const [id, row] of rows) if (!row) rows.delete(id);
    const scan = () => { const seen = new Set(); adapters.forEach(a => widget.querySelectorAll(a.item).forEach(review => {
      if (seen.has(review)) return;
      seen.add(review);
      const body = review.querySelector(a.body);
      const row = resolve(a.id(review), a.title(review), body && body.textContent, a.score(review), a.day(review), rows);
      const existing = review.querySelector('[data-mt-review-id]');
      const reply = review.querySelector(a.reply);
      const replyMatches = Boolean(row && sameReply(reply && reply.textContent, row.dataset.sourceReply));
      const signature = row ? `${row.dataset.reviewId}:${replyMatches}` : '';
      if (existing && existing.dataset.mtSignature === signature) return;
      if (existing) existing.remove();
      if (!row || !body) return;
      const details = row.content.firstElementChild.cloneNode(true);
      details.dataset.mtSignature = signature;
      const translatedReply = details.querySelector('[data-reviews-native-reply]');
      if (translatedReply && !replyMatches) translatedReply.remove();
      // A reply-only row whose live reply no longer matches has nothing left to translate: no accordion.
      if (!details.querySelector('[data-reviews-native-body]') && !(translatedReply && replyMatches)) return;
      details.open = false;
      (review.querySelector(a.anchor) || body).insertAdjacentElement('afterend', details);
    })); };
    const observer = new MutationObserver(scan);
    observer.observe(widget, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['data-review-id', 'data-score', 'data-content', 'review-uuid', 'aria-label'] });
    roots.set(root, observer);
    scan();
  };
  const start = () => document.querySelectorAll('[data-reviews-native]').forEach(attach);
  const unload = event => {
    for (const [root, observer] of roots) {
      if (event.target === root || event.target.contains(root)) { observer.disconnect(); roots.delete(root); }
    }
  };
  window.shangmengReviewsNative = { start };
  start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', unload);
})();
